<template>
  <FormSubmitPopup
      :title="$t('adjustBalance')"
      v-model="value"
      :rightMethod="onSubmitted"
      @popupClose="$emit('input', false)"
      medium>
      <template v-slot:input>
        <v-layout v-if="!isTenant" justify-space-between>
          <v-flex>
            <v-layout row wrap justify-space-between>
            <v-flex md3>
            <v-text-field
              :label="$t('amount')"
              prefix="$"
              class="required_field"
              v-model.number="adjustment.amount"
              :hint="$t('billingChangeHint')"
              persistent-hint
              :rules="[fieldIsNumber()]"></v-text-field>
          </v-flex>
          <v-flex md3>
            <v-select
              :label="$t('type')"
              class="required_field"
              :items="adjustType"
              item-text="text"
              item-value="value"
              v-model="adjustment.type"
              :rules="[fieldIsRequired()]"></v-select>
          </v-flex>
          <v-flex md5>
            <v-text-field
              :label="$t('keywords')"
              v-model.trim="adjustment.keywords"></v-text-field>
          </v-flex>
          </v-layout>
          </v-flex>
        <v-flex>
        </v-flex>
      </v-layout>
      <v-layout wrap justify-start align-center v-if="!isTenant">
        <v-flex sm10>
          <b>{{ $t('uploadedFiles') }}: </b>
          <v-layout row wrap>
            <FsFileChip
            v-for="(file, index) in (adjustment.attachments || [])"
            :file="file"
            :key="'file' + index"
            width="100%"
            aspect-ratio="1.7"
            class="ma-2"
          />
          </v-layout>
        </v-flex>
        <v-flex sm2>
          <UploadFileWidget
            v-model="adjustment.attachments"
            :clearFiles="true"
            ref="fileUploader"
            type="comments"
            :maxFiles="9"
            :removeFiles="removeFiles"
            icon
            isUseCameraUpload
          />
        </v-flex>
      </v-layout>
        <v-flex v-if="isTenant">
          <v-flex md6>
            <v-autocomplete
              :items="allUsers"
              item-text="name"
              return-object
              v-model="adjustment.userSelected"
              :label="$t('user')"
              :rules="[fieldIsRequired('user')]"
              class="required_field"
              clearable
            ></v-autocomplete>
          </v-flex>
          <v-flex md3>
            <v-text-field
              id="balance_amount"
              :label="$t('amount')"
              prefix="$"
              :hint="$t('billingChangeHint')"
              class="required_field"
              persistent-hint
              :rules="[fieldIsNumber()]"
              v-model.number="adjustment.amount"
            ></v-text-field>
          </v-flex>
        </v-flex>
        <v-flex v-if="adjustment.currencyType === '¥'">
          <v-icon color="warning">warning</v-icon>
          <span style="color:#2196F3">{{$t('noteRMBToUSD')}}</span>
        </v-flex>
        <v-layout>
          <v-textarea
            id="balance_note"
            :label="$t('note')"
            outline
            v-model="adjustment.note"></v-textarea>
        </v-layout>
      </template>
    </FormSubmitPopup>
</template>

<script>
import FormSubmitPopup from './FormSubmitPopup'
import { checkRules } from '@/utils/tools'
import UploadFileWidget from './UploadFileWidget.vue'
import FsFileChip from './FsFileChip.vue'

export default {
  name: 'AdjustBalancePopup',
  components: {
    FormSubmitPopup,
    UploadFileWidget,
    FsFileChip
  },
  mixins: [checkRules],
  data () {
    return {
      adjustType: [
        { text: this.$t('adjustBalance'), value: 'balance' },
        { text: this.$t('serviceFee'), value: 'fee' }
      ],
      removeFiles: 0
    }
  },
  mounted () {
    if (this.isFromOfflineDeposit) this.adjustType = [{ text: this.$t('adjustBalance'), value: 'balance' }]
  },
  methods: {
    onSubmitted () {
      return this.actionFunc()
        .then(() => {
          this.adjustment.attachments = []
          this.adjustment.amount = 0
          this.adjustment.note = ''
          this.adjustment.keywords = ''
          this.$store.dispatch('showToast', { info: this.$t('adjustBalanceSuccessful'), level: 'success' })
        })
        .catch((error) => {
          console.log(error.message)
          throw Error('Adjust-balance-failed.')
        })
    }
  },
  computed: {
    allUsers () {
      return this.$store.getters.users || []
    },
    isFromOfflineDeposit () {
      return !!this.adjustment.id
    },
    isTenant () {
      return !!this.$store.getters.activeOrganization
    }
  },
  props: {
    value: Boolean,
    adjustment: {
      type: Object,
      default: () => {
        return {}
      }
    },
    actionFunc: Function
  }

}
</script>



// WEBPACK FOOTER //
// src/components/AdjustBalancePopup.vue